<template>
<history-view :type="0" />
</template>

<script>
import HistoryView from '../../HistoryView'

export default {
  name: 'PMFAnalysisPMHistory',
  components: {HistoryView},
  routeInfo: {
    label: '历史数据',
    icon: 'fa fa-users'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/11PMF-Analysis/01PM/02History/index.vue